(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-selection-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.matreshSelectionReady) return;
  window.matreshSelectionReady = true;
  const KEY = 'matresh-selection-v1';
  const PENDING = 'matresh-selection-sent-v1';
  const safeUrl = (value, image = false) => {
    if (!value || typeof value !== 'string') return '';
    try {
      const url = new URL(value, window.location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      if (image) return url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.origin === location.origin) ? url.href : '';
      return url.origin === location.origin && url.pathname.includes('/products/') ? url.pathname : '';
    } catch { return ''; }
  };
  const normalise = (items) => {
    if (!Array.isArray(items)) return [];
    const unique = new Map();
    items.slice(0,100).forEach(item => {
      if (!item || !/^\d+$/.test(String(item.id)) || typeof item.title !== 'string') return;
      const url = safeUrl(item.url);
      if (!url) return;
      unique.set(String(item.id), {id:String(item.id), title:item.title.slice(0,250), sku:String(item.sku || '').slice(0,160), url, image:safeUrl(item.image || '',true)});
    });
    return [...unique.values()];
  };
  const read = () => { try { return normalise(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch { return []; } };
  let models = read();
  let toastTimer;
  const announce = (message) => {
    const status = document.querySelector('[data-ms-status]');
    if (!status) return;
    status.textContent = message;
    status.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { status.hidden = true; }, 4500);
  };
  const write = () => {
    try { localStorage.setItem(KEY, JSON.stringify(models)); return true; }
    catch { announce('Enable browser storage to save models between pages.'); return false; }
  };
  const syncButtons = () => {
    document.querySelectorAll('[data-ms-count]').forEach(el => { el.textContent = models.length; });
    document.querySelectorAll('[data-ms-add]').forEach(button => {
      const selected = models.some(item => item.id === button.dataset.modelId);
      button.disabled = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', (selected ? 'View selection with ' : 'Add to selection: ') + button.dataset.modelTitle);
      const label = button.querySelector('[data-ms-add-label]');
      if (label) label.textContent = selected ? '✓ Selected · View selection' : '+ Add to selection';
    });
  };
  const payload = () => models.map((item,index) => `${index+1}. ${item.title}\nModel ID: ${item.id}${item.sku ? '\nSKU: '+item.sku : ''}\nModel: ${new URL(item.url,location.origin).href}${item.image ? '\nPhoto: '+item.image : ''}`).join('\n\n');
  const render = () => {
    syncButtons();
    const list = document.querySelector('[data-ms-list]');
    if (!list) return;
    const fragment = document.createDocumentFragment();
    models.forEach(item => {
      const row = document.createElement('li'); row.className = 'ms-item';
      const photoLink = document.createElement('a'); photoLink.href = item.url; photoLink.setAttribute('aria-label', 'View '+item.title);
      const image = document.createElement('img'); image.className = 'ms-item-image'; image.alt = item.title; image.width=100; image.height=125; image.loading='lazy';
      if (item.image) { image.src=item.image; photoLink.append(image); }
      const detail = document.createElement('div');
      const name = document.createElement('a'); name.className='ms-item-name'; name.href=item.url; name.textContent=item.title;
      const sku = document.createElement('p'); sku.className='ms-item-sku'; sku.textContent=item.sku ? 'Model / SKU: '+item.sku : 'Model ref. '+item.id;
      const remove = document.createElement('button'); remove.type='button'; remove.className='ms-remove'; remove.dataset.msRemove=item.id; remove.textContent='Remove'; remove.setAttribute('aria-label','Remove '+item.title);
      detail.append(name,sku,remove); row.append(photoLink,detail); fragment.append(row);
    });
    list.replaceChildren(fragment);
    document.querySelector('[data-ms-empty]').hidden = models.length > 0;
    document.querySelector('[data-ms-content]').hidden = models.length === 0;
    document.querySelector('[data-ms-submit]').disabled = models.length === 0;
    document.querySelector('[data-ms-payload]').value = payload();
  };
  const init = () => {
    if (document.querySelector('[data-ms-success]')) {
      try {
        const sent = normalise(JSON.parse(sessionStorage.getItem(PENDING) || '[]'));
        models = models.filter(item => !sent.some(old => old.id === item.id));
        if (sent.length) write();
        sessionStorage.removeItem(PENDING);
      } catch {}
    }
    render();
    const form = document.getElementById('MatreshSelectionForm');
    if (form && !form.dataset.msBound) {
      form.dataset.msBound = 'true';
      form.addEventListener('submit', event => {
        const field = form.querySelector('[data-ms-payload]');
        if (!field || !models.length) { event.preventDefault(); announce('Add at least one model to request a quote.'); return; }
        field.value = payload();
        try { sessionStorage.setItem(PENDING,JSON.stringify(models)); } catch {}
      });
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ms-add]');
    if (button) {
      event.preventDefault(); event.stopPropagation();
      if (models.some(item => item.id === button.dataset.modelId)) {
        const selection = document.querySelector('[data-ms-link]');
        if (selection) window.location.assign(selection.href);
        return;
      }
      if (models.length >= 100) { announce('You can include up to 100 models in one enquiry.'); return; }
      models = normalise([...models,{id:button.dataset.modelId,title:button.dataset.modelTitle,url:button.dataset.modelUrl,sku:button.dataset.modelSku,image:button.dataset.modelImage}]);
      const saved = write(); render();
      if (saved) announce('Added to your selection · '+models.length+' models');
    }
    const remove = event.target.closest('[data-ms-remove]');
    if (remove) {
      const index = models.findIndex(item => item.id === remove.dataset.msRemove);
      models = models.filter(item => item.id !== remove.dataset.msRemove); write(); render();
      const remaining = document.querySelectorAll('[data-ms-remove]');
      (remaining[Math.min(index,remaining.length-1)] || document.querySelector('[data-ms-empty] a'))?.focus();
      announce('Model removed from your selection.');
    }
  });
  window.addEventListener('storage', event => { if (event.key === KEY || event.key === null) { models = read(); render(); } });
  window.addEventListener('pageshow', () => { models = read(); init(); });
  document.addEventListener('shopify:section:load', init);
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-ms-add]') || node.querySelector('[data-ms-add]'))))) return;
    queued = true; queueMicrotask(() => { syncButtons(); queued = false; });
  }).observe(document.documentElement,{childList:true,subtree:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
  } catch(e) { console.error(e); }
})();

})();
